<div class="container-fluid py-3 px-3 left-menu-space" id="divMainContainer">
  <div class="page-title-box d-sm-flex justify-content-between bd-highlight">
    <h4 class="mb-0 f-bold-dubai text-secondary pb-3">Search</h4>
    <div class="page-title-right pb-3" >
      <a style="display:none;" class="btn btn-success btn-sm text-white mx-2" (click)="openModalSearchAdd(searchtemplate)" title="Add Search"> <i class="ti ti-plus"></i> Save Search</a>
      <a class="btn btn-secondary btn-sm text-white" routerLink="/dashboard"><i class="fa fa-arrow-left"></i> Back</a>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="filter-section mb-3">
        <div class="card rounded pb-2 pt-3 mb-3 px-3">
          <div class="px-2">
            <div class="row">
              <div class="col-lg-3">
                <div class="row">
                  <label class="col-sm-4 pr-2 py-2">Search</label>
                  <input type="search" class="form-control pl-4 col-sm-8" [(ngModel)]="searchText" placeholder="Search" (keyup.enter)="getSearchList(true);">
                  <div class="position-absolute position-top-8 position-right-5"><i class="la la-search"></i></div>
                </div>               
              </div>
              <div class="col-lg-3">
                <div class="row">
                  <label class="col-sm-4 pr-2 py-2">Start Date</label>
                  <input  type="text" onfocus="(this.type='date')" placeholder="MM/DD/YYYY" class="form-control col-sm-8" name="startDate" [(ngModel)]="model.startDate" >
                </div>
              </div>
              <div class="col-lg-3">
                <div class="row">
                  <label class="col-sm-4 pr-2 py-2">End Date</label>
                  <input  type="text" onfocus="(this.type='date')" placeholder="MM/DD/YYYY" class="form-control col-sm-8" name="startDate" [(ngModel)]="model.endDate">
                </div>
              </div>
              <div class="col-lg-2">
                <div class="form-check form-check-inline px-3">
                  <input class="form-check-input" type="radio" name="inlineRadioOptions" [value]="2" [(ngModel)]="checkBoxVal" (click)="TypeCheckBoxSelection(2)" id="inlineRadio1" value="option1">
                  <label class="form-check-label" for="inlineRadio1">Attendance</label>
                </div>
                <div class="form-check form-check-inline px-3">
                  <input class="form-check-input" type="radio" name="inlineRadioOptions" [value]="1" [(ngModel)]="checkBoxVal" (click)="TypeCheckBoxSelection(1)" id="inlineRadio2" value="option2">
                  <label class="form-check-label" for="inlineRadio2">Meeting</label>
                </div>
              </div>
              <div class="col-lg-1 px-0">
                <button class="btn btn-dark btn-block mt-1" (click)="onSearch();"><i class="la la-search fa-lg pr-1"></i>Search</button>
              </div>
            </div>
        </div>
      </div>

      </div>
    </div>
  </div>
  <div class="p-0">
    <div class="row">
      <div class="col-12">
        <div class="bg-white py-4 text-center text-muted h-100 mb-3 rounded" *ngIf="lstMOMDashboard_MyMeetings.length ===0 || lstMOMDashboard_MyMeetings ==null ">
          <!--<img src="{{noDataImage}}" class="img-fluid" alt="No Data" />-->
          <h5>No Data Available</h5>
        </div>
      </div>
      <div class="col-md-4 mb-3" id="pageloadcontainer" *ngFor="let item of lstMOMDashboard_MyMeetings">
        <div class="card rounded py-3 mb-3 h-100">
          <div class=" px-3 border-bottom">
            <h6  class="card-title d-inline f-bold-dubai pt-1"><span class="pt-2"><i class="la la-calendar-o fa-lg"></i>{{item.meetingDate}}</span></h6>
            <div class="card-controls float-right pt-0">
              <ul class="list-inline list-badge hide-arrow-drop mb-1">

                <li class="list-inline-item d-none-view hide-v-line">
                  <i *ngIf="item.approvalStatus!='Published'" [title]="item.approvalStatus" class="fa fa-unlock mar-10 fa-lg"></i> <i *ngIf="item.approvalStatus=='Published'" title="Published" class="fa fa-lock mar-10"></i>

                </li>
                <li class="list-inline-item nav-item" ngbDropdown>
                  <a class="nav-link p-0" id="dropdownBasic1" ngbDropdownToggle><i class="la la-ellipsis-v fa-lg"></i></a>
                  <ul ngbDropdownMenu aria-labelledby="dropdownBasic1">
                    <!--<li><a ngbDropdownItem><i class="fa fa-edit"></i> Edit</a></li>-->
                    <li><a ngbDropdownItem (click)="openModalnewMeeting(template1,item.genInfoAtdUno)"><i class="fa fa-eye"></i> View</a></li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-12">
                <div class="float-left">
                  <div class="text-center py-2">
                    <div class="d-inline my-1">
                      <div class="float-left p-1 text-secondary"><i class="la la-clock-o fa-lg"></i></div>
                      <div class="float-left p-1 text-secondary"><small>{{item.startTime  | timeFormat}}</small></div>
                    </div>
                    <div class="d-inline my-1">
                      <div class="float-left p-1 text-secondary"><i class="la la-clock-o fa-lg"></i></div>
                      <div class="float-left p-1 text-secondary"><small>{{item.endTime  | timeFormat}}</small></div>
                    </div>
                  </div>
                </div>
                <div class="float-right py-2" (click)="openModalnewMeeting(template1,item.genInfoAtdUno)">
                  <a *ngIf="item.approvalStatus=='Draft'" data-toggle="refresh" class="btn btn-sm btn-outline-secondary"> {{item.approvalStatus}}</a>
                  <a *ngIf="item.approvalStatus =='Under Review' || item.approvalStatus =='Reviewed'" data-toggle="refresh" class="btn btn-sm btn-outline-warning"> {{item.approvalStatus}}</a>
                  <a *ngIf="item.approvalStatus =='Approved'|| item.approvalStatus == 'Pending Approval'" data-toggle="refresh" class="btn btn-sm btn-outline-primary"> {{item.approvalStatus}}</a>
                  <a *ngIf="item.approvalStatus=='Published'" data-toggle="refresh" class="btn btn-sm btn-outline-success"> {{item.approvalStatus}}</a>
                </div>
              </div>
              <div class="col-md-12" (click)="openModalnewMeeting(template1,item.genInfoAtdUno)">
                <div class="mx-2">
                  <a class="text-secondary d-block pl-4 position-relative mb-2"><i class="la la-group fa-lg pr-2 position-absolute position-top-0 position-left-0"></i>{{item.meetingName}}</a>
                  <a class="text-secondary d-block pl-4 position-relative mb-2"><i class="la la-map-marker fa-lg pr-2 position-absolute position-top-0 position-left-0"></i> {{item.meetingLocation}}</a>
                  <a class="text-secondary d-block pl-4 position-relative mb-2"><i class="la la-file-text fa-lg pr-2 position-absolute position-top-0 position-left-0"></i>  {{item.subjectAtd}}</a>
                  <a class="text-secondary d-block pl-4 position-relative mb-2"><i class="la la-file fa-lg pr-2 position-absolute position-top-0 position-left-0"></i> {{item.meetingRoom}}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>

<ng-template #template1>
  <div class="modal-header border-0 pb-0">
    <div class="custom-tab d-block w-100">
      <button type="button" class="close hide close-abs pull-right text-right" id="editclose" name="editclose" #editclose aria-label="Close" (click)="modalMeeting.hide();">
        <span aria-hidden="true"></span>
      </button>

    </div>
  </div>
  <div *ngIf="pagetype=='MEETING'">
    <app-view-meeting pagetype="MEETING" [mid]="mid"></app-view-meeting>
  </div>
  <div *ngIf="pagetype=='ATTENDANCE'">
    <app-view-attendence pagetype="ATTENDANCE" [mid]="mid"></app-view-attendence>
  </div>


</ng-template>
<ng-template #searchtemplate>
  <div class="modal-header">
    <h4 class="modal-title pull-left f-bold-dubai">Search Add and View</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalSearch.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body py-3">
    <div class="position-relative px-3">
      <div class="custom-tab">
        <div class="row">
          <div class="col-7 col-sm-10 px-0">
            <input type="text" id="searchAdd" class="form-control mb-3" [(ngModel)]="searchAdd" />
          </div>

          <div class="col-5 col-sm-2 rr-0">
            <div class="form-group">
              <button class="btn btn-success btn-block" (click)="AddSearchText()">Submit</button>
            </div>
          </div>
        </div>
      </div>
    </div>
      <div class="card rounded hide-last-border">
        <div class="py-1 pl-3 pr-4 border-bottom position-relative" *ngFor="let item of data">
          <div class="card-controls position-absolute position-top-0 position-right-15">
            <div class="form-check">
            <a (click)="searchTextFilter(item)"><i class="fa fa-check-circle-o" aria-hidden="true"></i></a>      
            </div>
          </div>
            <h6 class="card-title d-inline f-bold-dubai">{{item.searchText}}</h6>
            <div class="text-success py-1">{{item.actionType}}</div>
        </div>
        <div class="border rounded py-4 text-center text-muted h-100" *ngIf="data==null ||data.length==0 ">
          <img src="{{noDataImage}}" class="img-fluid" alt="No Data" />
          <!--<h5>No Data Found</h5>-->
        </div>
      </div>

  </div>

</ng-template>
